import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom'; 
import { fetchMissionEvents } from "../Apis/AdminApis";
import './MissionEvents.css';
import Sidebar from "../Sidebar/Sidebar";
import pavamanLogo from "../images/drone.png";
import { 
  FiClock, 
  FiCalendar, 
  FiActivity, 
  FiChevronDown, 
  FiChevronRight,
  FiChevronLeft,
  FiChevronRight as FiChevronRightArrow,
  FiAlertCircle,
  FiFlag,
  FiFilter,
  FiRefreshCw,
  FiSearch,
  FiX,
  FiPlayCircle 
} from 'react-icons/fi';
import { MdFlightTakeoff, MdFlightLand, MdBatteryAlert } from 'react-icons/md';
import { GiDeliveryDrone } from 'react-icons/gi';
import alertIcon from "../images/alert.png";
import droneStartIcon from "../images/drone start.png";
import droneEndIcon from "../images/seesaw_18339994.png";
import PopupMessage from "../PopupMessage/PopupMessage";

const MissionEvents = () => {
  const navigate = useNavigate(); 
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedVehicles, setExpandedVehicles] = useState({});
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [allVehicles, setAllVehicles] = useState([]);
  const [filterType, setFilterType] = useState('month');
  const [dateRange, setDateRange] = useState({
    start_date: '',
    end_date: ''
  });
  const [searchTerm, setSearchTerm] = useState('');
  const [currentVehiclePage, setCurrentVehiclePage] = useState(1);
  const [vehiclesPerPage] = useState(10);
  const [totalVehicles, setTotalVehicles] = useState(0);
  const [totalVehiclePages, setTotalVehiclePages] = useState(1);
  const [missionsPageMap, setMissionsPageMap] = useState({});
  const [missionsPerPage] = useState(10);
  const [eventsPageMap, setEventsPageMap] = useState({});
  const [eventsPerPage] = useState(10); 
  const [isPaginationLoading, setIsPaginationLoading] = useState(false);

  const [popupOpen, setPopupOpen] = useState(false);
const [popupMessage, setPopupMessage] = useState("");
const [popupType, setPopupType] = useState("info");

useEffect(() => {
  if (filterType === "custom") {
    if (dateRange.start_date && dateRange.end_date) {
      loadEvents(
        "custom",
        dateRange.start_date,
        dateRange.end_date,
        currentVehiclePage
      );
    }
  } else {
    loadEvents(filterType);
  }
}, [
  currentVehiclePage,
  filterType,
  dateRange.start_date,
  dateRange.end_date,
]);

const loadEvents = async (
  overrideFilterType = filterType,
  overrideStartDate = dateRange.start_date,
  overrideEndDate = dateRange.end_date,
  overridePage = currentVehiclePage
) => {
    try {
      setLoading(true);
      setIsPaginationLoading(false);
      
  let payloadFilterType = overrideFilterType;
let payloadDate = new Date().toISOString().split('T')[0];

if (overrideFilterType === 'custom') {
  if (!overrideStartDate || !overrideEndDate) {
    setLoading(false);
    return;
  }
} else {
  payloadDate = new Date().toISOString().split('T')[0];
}
      
const data = await fetchMissionEvents(
  overridePage,
  vehiclesPerPage,
  1,
  missionsPerPage,
  1,
  eventsPerPage,
  payloadFilterType,
  payloadDate,
  overrideStartDate,
  overrideEndDate
);
      
      let vehiclesList = [];
      let paginationInfo = {};
      
      if (data.type === "single") {
        vehiclesList = data.data || [];
        paginationInfo = data.vehicle_pagination || {};
      } else if (data.type === "multi") {
        vehiclesList = data.superadmin_company?.data || [];
        paginationInfo = data.superadmin_company?.vehicle_pagination || {};
      }
      
      setAllVehicles(vehiclesList);
      setEvents(vehiclesList);
      setTotalVehicles(paginationInfo.total_vehicles || 0);
      setTotalVehiclePages(paginationInfo.total_pages || 1);
      setError(null);
    } catch (err) {
        if (
    err?.response?.status === 401 ||
    err?.message?.includes("Unauthorized")
  ) {
    setPopupMessage("Session expired, redirecting to login page");
    setPopupType("error");
    setPopupOpen(true);

    setTimeout(() => {
      navigate("/login");
    }, 2000);

    return;
  }

      setError('Failed to load mission events');
      console.error(err);
    } finally {
      setLoading(false);
      setIsPaginationLoading(false);
    }
  };

  const loadVehicleWithMissions = async (vehicleId, missionPage) => {
    try {
      setIsPaginationLoading(true);
      
      let payloadFilterType = filterType;
      let payloadDate = new Date().toISOString().split('T')[0];
      
      if (filterType === 'custom') {
        payloadFilterType = 'custom';
      } else {
        payloadDate = new Date().toISOString().split('T')[0];
      }
      
      const data = await fetchMissionEvents(
        currentVehiclePage,
        vehiclesPerPage,
        missionPage,
        missionsPerPage,
        1,                  
        eventsPerPage,
        payloadFilterType,
        payloadDate,
        dateRange.start_date,
        dateRange.end_date
      );
      
      let vehiclesList = [];
      if (data.type === "single") {
        vehiclesList = data.data || [];
      } else if (data.type === "multi") {
        vehiclesList = data.superadmin_company?.data || [];
      }
      
      const updatedVehicle = vehiclesList.find(v => v.vehicle_id === vehicleId);
      if (updatedVehicle) {
        setAllVehicles(prev => 
          prev.map(v => 
            v.vehicle_id === vehicleId 
              ? { 
                  ...updatedVehicle,
                  missions: updatedVehicle.missions || [],
                  missions_pagination: updatedVehicle.missions_pagination || {}
                }
              : v
          )
        );
        setEvents(prev => 
          prev.map(v => 
            v.vehicle_id === vehicleId 
              ? { 
                  ...updatedVehicle,
                  missions: updatedVehicle.missions || [],
                  missions_pagination: updatedVehicle.missions_pagination || {}
                }
              : v
          )
        );
      }
    } catch (err) {
      if (
  err?.response?.status === 401 ||
  err?.message?.includes("Unauthorized")
) {
  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  setTimeout(() => {
    navigate("/login");
  }, 2000);

  return;
}
      console.error('Failed to load vehicle missions:', err);
    } finally {
      setIsPaginationLoading(false);
    }
  };

  const loadMissionEvents = async (vehicleId, missionId, eventPage, currentMissionPage) => {
    try {
      setIsPaginationLoading(true);
      
      let payloadFilterType = filterType;
      let payloadDate = new Date().toISOString().split('T')[0];
      
      if (filterType === 'custom') {
        payloadFilterType = 'custom';
      } else {
        payloadDate = new Date().toISOString().split('T')[0];
      }
      
      const data = await fetchMissionEvents(
        currentVehiclePage, 
        vehiclesPerPage, 
        currentMissionPage, 
        missionsPerPage,    
        eventPage, 
        eventsPerPage,
        payloadFilterType, 
        payloadDate,
        dateRange.start_date,
        dateRange.end_date
      );
      
      let vehiclesList = [];
      if (data.type === "single") {
        vehiclesList = data.data || [];
      } else if (data.type === "multi") {
        vehiclesList = data.superadmin_company?.data || [];
      }
      
      const updatedVehicle = vehiclesList.find(v => v.vehicle_id === vehicleId);
      if (updatedVehicle) {
        const updatedMission = updatedVehicle.missions?.find(m => m.mission_id === missionId);
        if (updatedMission) {
          setAllVehicles(prev => 
            prev.map(v => {
              if (v.vehicle_id === vehicleId) {
                return {
                  ...v,
                  missions: v.missions?.map(m =>
                    m.mission_id === missionId
                      ? { 
                          ...m, 
                          events: updatedMission.events || [],
                          events_pagination: updatedMission.events_pagination || {}
                        }
                      : m
                  )
                };
              }
              return v;
            })
          );
          setEvents(prev => 
            prev.map(v => {
              if (v.vehicle_id === vehicleId) {
                return {
                  ...v,
                  missions: v.missions?.map(m =>
                    m.mission_id === missionId
                      ? { 
                          ...m, 
                          events: updatedMission.events || [],
                          events_pagination: updatedMission.events_pagination || {}
                        }
                      : m
                  )
                };
              }
              return v;
            })
          );
        }
      }
    } catch (err) {
      if (
  err?.response?.status === 401 ||
  err?.message?.includes("Unauthorized")
) {
  setPopupMessage("Session expired, redirecting to login page");
  setPopupType("error");
  setPopupOpen(true);

  setTimeout(() => {
    navigate("/login");
  }, 2000);

  return;
}
      console.error('Failed to load mission events:', err);
    } finally {
      setIsPaginationLoading(false);
    }
  };

const handleMissionReplay = (mission, vehicle) => {
  let pilotId = mission.pilot_id ||
    (mission.events && mission.events.length > 0 && mission.events[0].pilot_id) ||
    vehicle?.pilot_id ||
    localStorage.getItem('pilot_id') ||
    'default_pilot_id';
  
  const missionData = {
    mission_id: mission.mission_id,
    vehicle_id: mission.vehicle_id || vehicle?.vehicle_id,
    pilot_id: pilotId,
    drone_name: vehicle?.vehicle_name,
    pilot_name: mission.pilot_name || mission.events?.[0]?.pilot_name,
    mission_status: mission.mission_status,
    fromPage: 'mission-events'
  };
  
  if (missionData.mission_id && missionData.vehicle_id && missionData.pilot_id) {
    navigate('/admin/mission-replay', { 
      state: { missionData } 
    });
  } else {
    alert(`Missing required data: mission_id=${missionData.mission_id}, vehicle_id=${missionData.vehicle_id}, pilot_id=${missionData.pilot_id}`);
  }
};

  const getEventTypeIcon = (type) => {
    const typeLower = type?.toLowerCase() || '';

    if (typeLower.includes('end') || typeLower.includes('land')) {
      return { icon: droneEndIcon, label: 'Ended', color: '#EF4444' };
    } else if (typeLower.includes('start') || typeLower.includes('takeoff')) {
      return { icon: droneStartIcon, label: 'Started', color: '#10B981' };
    } else if (
      typeLower.includes('error') ||
      typeLower.includes('fail') ||
      typeLower.includes('battery')
    ) {
      return { icon: alertIcon, label: 'Alert', color: '#F59E0B' };
    } else {
      return { icon: alertIcon, label: 'Event', color: '#F59E0B' };
    }
  };

  const formatDateTime = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  const formatTimeAgo = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMins / 60);
    const diffDays = Math.floor(diffHours / 24);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    return `${diffDays}d ago`;
  };

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalVehiclePages) {
      setIsPaginationLoading(true);
      setCurrentVehiclePage(newPage);
      setExpandedVehicles({});
      setSelectedVehicle(null);
      setMissionsPageMap({});
      setEventsPageMap({});
    }
  };

  const toggleVehicle = (vehicleId) => {
    setExpandedVehicles(prev => ({
      ...prev,
      [vehicleId]: !prev[vehicleId]
    }));
    
    if (!expandedVehicles[vehicleId]) {
      setSelectedVehicle(vehicleId);
      if (!missionsPageMap[vehicleId]) {
        setMissionsPageMap(prev => ({ ...prev, [vehicleId]: 1 }));
      }
    } else {
      setSelectedVehicle(null);
    }
  };

  const handleMissionsPageChange = async (vehicleId, newPage) => {
    if (newPage < 1) return;
    const vehicle = allVehicles.find(v => v.vehicle_id === vehicleId);
    const totalPages = vehicle?.missions_pagination?.total_pages || 1;
    if (newPage > totalPages) return;
    
    setMissionsPageMap(prev => ({ ...prev, [vehicleId]: newPage }));
    await loadVehicleWithMissions(vehicleId, newPage);
  };

  const handleEventsPageChange = async (vehicleId, missionId, newPage) => {
    if (newPage < 1) return;
    const vehicle = allVehicles.find(v => v.vehicle_id === vehicleId);
    const mission = vehicle?.missions?.find(m => m.mission_id === missionId);
    const totalPages = mission?.events_pagination?.total_pages || 1;
    if (newPage > totalPages) return;
    
    const eventKey = `${vehicleId}_${missionId}`;
    setEventsPageMap(prev => ({ ...prev, [eventKey]: newPage }));
    const currentMissionPage = missionsPageMap[vehicleId] || 1;
    await loadMissionEvents(vehicleId, missionId, newPage, currentMissionPage);
  };

  const getStatusBadge = (vehicle) => {
    const hasActiveMissions = vehicle.missions?.some(m => 
      m.events?.some(e => e.event_status === 'active')
    );
    return hasActiveMissions 
      ? { label: 'Active Mission', color: '#10B981', bg: '#D1FAE5', icon: '●' }
      : { label: 'Inactive Mission', color: '#6B7280', bg: '#F3F4F6', icon: '○' };
  };

  const handleFilterChange = (type) => {
    setFilterType(type);
    setCurrentVehiclePage(1);
    setExpandedVehicles({});
    setMissionsPageMap({});
    setEventsPageMap({});
    if (type !== 'custom') {
      setDateRange({ start_date: '', end_date: '' });
    }
  };

  const handleDateRangeChange = (field, value) => {
    setDateRange(prev => ({ ...prev, [field]: value }));
  };

const applyCustomDateRange = async () => {
  const { start_date, end_date } = dateRange;

  if (!start_date || !end_date) {
    setError("Please select both start and end dates");
    return;
  }

  const today = new Date().toISOString().split("T")[0];

  if (start_date > today || end_date > today) {
    setError("Future dates are not allowed");
    return;
  }

  if (start_date > end_date) {
    setError("Start date cannot be after end date");
    return;
  }

  setError(null);

  // IMPORTANT
  setFilterType("custom");

  setExpandedVehicles({});
  setMissionsPageMap({});
  setEventsPageMap({});
  setCurrentVehiclePage(1);

  await loadEvents("custom", start_date, end_date, 1);
};

  const handleResetFilters = () => {
    setFilterType('month');
    setDateRange({ start_date: '', end_date: '' });
    setSearchTerm('');
    setCurrentVehiclePage(1);
    setExpandedVehicles({});
    setMissionsPageMap({});
    setEventsPageMap({});
    loadEvents();
  };

  const filteredEvents = useMemo(() => {
    const term = searchTerm.toLowerCase();

    return allVehicles.filter(vehicle => {
      const name = vehicle.vehicle_name?.toLowerCase() || '';
      const id = vehicle.vehicle_id?.toLowerCase() || '';

      return name.includes(term) || id.includes(term);
    });
  }, [allVehicles, searchTerm]);

  const isApiEmpty = allVehicles.length === 0;
  const isSearchEmpty = filteredEvents.length === 0;

  return (
    <div className="dashboard-wrapper">
      <Sidebar />
      <PopupMessage
        isOpen={popupOpen}
        onClose={() => setPopupOpen(false)}
        message={popupMessage}
        type={popupType}
      />
      <div className="dashboard-content">
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Drone Mission Events</h1>
            <p className="dashboard-subtitle">Track and monitor all drone mission activities in real-time</p>
          </div>
          
          <div className="header-right">
            <button 
              className="filter-toggle-btn"
              onClick={() => setShowFilters(!showFilters)}
            >
              <FiFilter size={18} />
              {showFilters ? "Hide Filters" : "Show Filters"}
            </button>
          </div>
        </div>

        {showFilters && (
          <div className="filters-section-flights">
            <div className="filters-grid">
              <div className="filter-group">
                <label>Start Date</label>
                <input
  type="date"
  max={new Date().toISOString().split('T')[0]}
  value={dateRange.start_date}
  onChange={(e) => handleDateRangeChange('start_date', e.target.value)}
  className="filter-input"
/>
              </div>
              <div className="filter-group">
                <label>End Date</label>
                <input
  type="date"
  max={new Date().toISOString().split('T')[0]}
  value={dateRange.end_date}
  onChange={(e) => handleDateRangeChange('end_date', e.target.value)}
  className="filter-input"
/>
              </div>
            </div>
            <div className="filter-actions">
              <button 
                className="apply-filters-btn" 
                onClick={applyCustomDateRange}
                disabled={!dateRange.start_date || !dateRange.end_date || loading}
              >
                {loading ? "Applying..." : "Apply Filters"}
              </button>
              <button className="reset-filters-btn" onClick={handleResetFilters}>
                Reset
              </button>
            </div>
          </div>
        )}
<div className="default-filter-info">
  {filterType === "custom" ? (
    dateRange.start_date &&
    dateRange.end_date && (
      <span>
        📅 Showing mission data from {dateRange.start_date} to {dateRange.end_date}
      </span>
    )
  ) : (
    <span>
      📅 Current month data is being displayed by default. Use filters to view a different date range.
    </span>
  )}
</div>
        <div className="pv-search-bar">
          <FiSearch className="pv-search-icon" />
          <input
            type="text"
            placeholder="Search by drone name or ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="pv-search-input"
          />
          {searchTerm && (
            <button className="pv-clear-search" onClick={() => setSearchTerm("")}>
              <FiX size={18} />
            </button>
          )}
        </div>

        {error && (
          <div className="me-error">
            <FiAlertCircle className="me-error-icon" />
            <span>{error}</span>
            <button onClick={loadEvents} className="me-error-retry">Retry</button>
          </div>
        )}

        {(loading && !isPaginationLoading) ? (
          <div className="custom-loading-container">
            <img src={pavamanLogo} alt="Loading" className="spinning-logo" />
            <p className="loading-text">Loading drone mission events data...</p>
          </div>
        ) : isApiEmpty ? (
          <div className="me-empty">
            <div className="me-empty-icon">🚁</div>
            <h3>No Data Found</h3>
            <p>No mission events for selected filters.</p>
          </div>
        ) : isSearchEmpty ? (
          <div className="me-empty">
            <div className="me-empty-icon">🔍</div>
            <h3>No Results Found</h3>
            <p>No drones match your search.</p>
          </div>
        ) : (
          <>
          

            <div className="me-vehicles-list">
              {filteredEvents.map((vehicle) => {
                const isExpanded = expandedVehicles[vehicle.vehicle_id];
                const status = getStatusBadge(vehicle);
                const latestEvent = vehicle.missions?.[0]?.events?.[0];
                const currentMissionPage = missionsPageMap[vehicle.vehicle_id] || 1;
                const totalMissionPages = vehicle.missions_pagination?.total_pages || 1;
                const currentMissions = vehicle.missions || [];
                
                return (
                  <div key={vehicle.vehicle_id} className="me-vehicle-item">
                    <div 
                      className={`me-vehicle-card ${isExpanded ? 'expanded' : ''}`}
                      onClick={() => toggleVehicle(vehicle.vehicle_id)}
                    >
                      <div className="me-vehicle-icon">
                        <GiDeliveryDrone />
                      </div>
                      
                      <div className="me-vehicle-info">
                        <h3 className="me-vehicle-name">
                          {vehicle.vehicle_name || vehicle.vehicle_id || 'Unknown Drone'}
                        </h3>
                        <div className="me-vehicle-meta">
                          <span className="me-vehicle-id">ID: {vehicle.vehicle_id}</span>
                          <span className={`me-vehicle-status ${status.label === 'Active Mission' ? 'active' : 'inactive'}`}>
                            <span className="me-status-dot"></span>
                            {status.label}
                          </span>
                        </div>
                      </div>
                      
                      <div className="me-vehicle-stats">
                        <div className="me-stat-badge">
                          <FiActivity />
                          <span>{vehicle.missions_pagination?.total_missions || 0} Missions</span>
                        </div>
                        {latestEvent && (
                          <div className="me-stat-badge">
                            <FiClock />
                            <span>{formatTimeAgo(latestEvent.created_at)}</span>
                          </div>
                        )}
                      </div>
                      
                      <div className="me-vehicle-expand">
                        {isExpanded ? <FiChevronDown /> : <FiChevronRight />}
                      </div>
                    </div>

                    {isExpanded && (
                      <div className="me-expanded-events">
                        <div className="me-events-header">
                          <h4>Drone Mission Timeline</h4>
                          <span className="me-events-count">
                            {vehicle.missions_pagination?.total_missions || 0} total missions
                          </span>
                        </div>

                        {currentMissions.length > 0 ? (
                          currentMissions.map((mission, mIdx) => {
                            const missionEvents = mission.events || [];
                            const eventKey = `${vehicle.vehicle_id}_${mission.mission_id}`;
                            const currentEventPage = eventsPageMap[eventKey] || 1;
                            const totalEventPages = mission.events_pagination?.total_pages || 1;
                            
                            return (
                              <div key={mission.mission_id || mIdx} className="me-mission-container">
                                <div className="me-mission-header">
                                  <div className="me-mission-title">
                                    <FiFlag className="me-mission-icon" />
                                    <span className="mission-id">Mission: {mission.mission_id}</span>
                                  </div>
                                  <div className="me-mission-actions">
                                    <span className="me-mission-badge">
                                      {mission.events_pagination?.total_events || 0} events
                                    </span>
                                    <button 
                                      className="me-replay-btn"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleMissionReplay(mission, vehicle);
                                      }}
                                      title="Replay Mission"
                                    >
                                      <FiPlayCircle size={16} />
                                      Replay
                                    </button>
                                  </div>
                                </div>
                                
                                <div className="me-events-timeline">
                                  {missionEvents.map((event, eIdx) => {
                                    const { icon, label, color } = getEventTypeIcon(event.event_type);
                                    return (
                                      <div key={event.event_id || eIdx} className="me-timeline-event">
                                        <div className="me-timeline-marker">
                                          <img src={icon} alt="event-icon" className="me-custom-icon" />
                                        </div>
                                        
                                        <div className="me-timeline-content">
                                          <div className="me-timeline-header">
                                            <span className="me-timeline-type" style={{ color }}>
                                              {label}
                                            </span>
                                            <span className="me-timeline-time">
                                              {formatDateTime(event.created_at)}
                                            </span>
                                          </div>
                                          
                                          <p className="me-timeline-description">
                                            {event.event_description || 'No description available'}
                                          </p>
                                          
                                          {event.pilot_name && (
                                            <div className="me-timeline-pilot">
                                              <span>👨‍✈️ Pilot: {event.pilot_name}</span>
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>

                                {totalEventPages > 1 && (
                                  <div className="me-mission-pagination">
                                    <button
                                      className="me-pagination-small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleEventsPageChange(vehicle.vehicle_id, mission.mission_id, currentEventPage - 1);
                                      }}
                                      disabled={currentEventPage === 1 || isPaginationLoading}
                                    >
                                      <FiChevronLeft /> Prev
                                    </button>
                                    <span className="me-page-info">
                                      Page {currentEventPage} of {totalEventPages}
                                    </span>
                                    <button
                                      className="me-pagination-small"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        handleEventsPageChange(vehicle.vehicle_id, mission.mission_id, currentEventPage + 1);
                                      }}
                                      disabled={currentEventPage === totalEventPages || isPaginationLoading}
                                    >
                                      Next <FiChevronRightArrow />
                                    </button>
                                  </div>
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <div className="me-no-events">
                            <FiAlertCircle />
                            <p>No missions found for this drone</p>
                          </div>
                        )}

                        {totalMissionPages > 1 && (
                          <div className="me-missions-pagination">
                            <button
                              className="me-pagination-small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMissionsPageChange(vehicle.vehicle_id, currentMissionPage - 1);
                              }}
                              disabled={currentMissionPage === 1 || isPaginationLoading}
                            >
                              <FiChevronLeft /> Previous Missions
                            </button>
                            <span className="me-page-info">
                              Page {currentMissionPage} of {totalMissionPages}
                            </span>
                            <button
                              className="me-pagination-small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleMissionsPageChange(vehicle.vehicle_id, currentMissionPage + 1);
                              }}
                              disabled={currentMissionPage === totalMissionPages || isPaginationLoading}
                            >
                              Next Missions <FiChevronRightArrow />
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>

            {totalVehiclePages > 1 && events.length > 0 && (
              <div className="pv-pilot-pagination-wrapper">
                <div className="pv-pilot-pagination-controls">
                  <button
                    className="pv-pilot-pagination-btn"
                    onClick={() => handlePageChange(currentVehiclePage - 1)}
                    disabled={currentVehiclePage === 1 || isPaginationLoading}
                  >
                    <FiChevronLeft size={16} />
                    Previous
                  </button>
                  
                  <div className="pv-pilot-page-numbers">
                    {Array.from({ length: Math.min(5, totalVehiclePages) }, (_, i) => {
                      let pageNumber;
                      if (totalVehiclePages <= 5) {
                        pageNumber = i + 1;
                      } else if (currentVehiclePage <= 3) {
                        pageNumber = i + 1;
                      } else if (currentVehiclePage >= totalVehiclePages - 2) {
                        pageNumber = totalVehiclePages - 4 + i;
                      } else {
                        pageNumber = currentVehiclePage - 2 + i;
                      }
                      return (
                        <button
                          key={pageNumber}
                          className={`pv-pilot-page-btn ${currentVehiclePage === pageNumber ? 'pv-pilot-active' : ''}`}
                          onClick={() => handlePageChange(pageNumber)}
                          disabled={isPaginationLoading}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}
                  </div>
                  
                  <button
                    className="pv-pilot-pagination-btn"
                    onClick={() => handlePageChange(currentVehiclePage + 1)}
                    disabled={currentVehiclePage === totalVehiclePages || isPaginationLoading}
                  >
                    Next <FiChevronRight size={16} />
                  </button>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default MissionEvents;